import * as React from "react";

// import _ from 'lodash';

// translation
import {translate} from "react-i18next";

// app state and redux
import {connect, Dispatch} from "react-redux";

// view container
import ViewContainer from "../ViewContainer";

// components
import GeneralActions from "../../redux/actions/GeneralActions";
import {compose} from "redux";
import {IReduxState} from "../../redux/IReduxState";
import {ITranslatedComponent} from "src/redux/reducers/generalReducer";
import ErrorBoundary from "../../utils/ErrorBoundary";
import {Tab} from "semantic-ui-react";
import SupportFaq from "./SupportFaqTab/SupportFaq";
import {MenuDto} from "../../services/Client";
import SupportViewActions from "../../redux/actions/SupportViewActions";
import HATEOASClient from "../../services/HATEOASClient";
import {selectBaseLinks, selectClient} from "../../redux/selectors";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";

interface IMapStateToProps {
    client: HATEOASClient;
    baseLinks?: MenuDto;
}

interface IMapDispatchToProps {
    AddTranslationLocation: () => void;
    receiveSupportAreaLinks: (supportAreaLinks: MenuDto) => void;
}

interface ISupportViewState {
    supportAreaLinks?: MenuDto;
    /** Active tab index. */
    activeIndex: number;
}

interface ISupportViewProps extends
    IMapDispatchToProps,
    ITranslatedComponent,
    IMapStateToProps { }

/**
 * A container view for the support view
 */
class SupportView extends React.Component<ISupportViewProps, ISupportViewState> {
    state: ISupportViewState = {
        supportAreaLinks: undefined,
        activeIndex: 0
    };

    constructor(props: ISupportViewProps) {
        super(props);
    }

    componentDidMount() {
        this.props.AddTranslationLocation();

        if (this.props.baseLinks) {
            this.requestSupportAreaLinks(this.props.baseLinks);
        }
    }

    componentWillReceiveProps(newProps: ISupportViewProps) {
        if (!this.props.baseLinks && newProps.baseLinks) {
            // the base links were received in the meantime
            this.requestSupportAreaLinks(newProps.baseLinks);
        }
    }

    requestSupportAreaLinks = (baseLinks: MenuDto) => {
        if (!this.props.client.GET_supportArea(baseLinks).canExecute()) {
            return;
        }

        // request the links to populate supported ui-controls
        this.props.client.GET_supportArea(baseLinks).execute()
            .then((supportAreaLinks: MenuDto) => {
                this.setState({supportAreaLinks: supportAreaLinks});
                this.props.receiveSupportAreaLinks(supportAreaLinks);
            })
            .catch((reason: any) => {
                window.scrollTo(0, 0);
                renderErrorToast({
                                     message: "ERRORS:GET_SUPPORT_AREA_LINKS",
                                     details: reason,
                                     timestamp: Date.now()
                                 });
            });
    }

    render() {
        const panes = [];

        if (this.state.supportAreaLinks) {
            panes.push({
                           menuItem: {content: this.props.t("SUPPORT_VIEW:FAQ"), icon: 'question circle', key: 'faq'},
                           render: () => <Tab.Pane key='access'><SupportFaq {...this.props} /></Tab.Pane>
                       });
        }
        return (
            <ViewContainer viewContainerContentAlternateClass="viewContainerContent_height_90">
                <div className='admin-view-content-container'>
                    <ErrorBoundary >
                        <Tab
                            menu={{fluid: true, vertical: false, tabular: true}}
                            panes={panes}
                            onTabChange={(e: any, d: any) => this.setState({activeIndex: d.activeIndex})}
                        />
                    </ErrorBoundary>
                </div>
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),

});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    AddTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({pattern: "support", substitutes: "SUPPORT"})),
    receiveSupportAreaLinks: (supportAreaLinks: MenuDto) => dispatch(SupportViewActions.ReceiveSupportareaLinks(supportAreaLinks))
});

export default compose(
    translate("SUPPORT_VIEW"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(SupportView);



// WEBPACK FOOTER //
// ./src/views/SupportView/SupportView.tsx